export default __webpack_public_path__ + "static/media/blog.8c034ea7.gif";